export function fmtMoney(n, opts = {}) {
  if (n === null || n === undefined || n === "" || isNaN(Number(n))) return "—";
  const v = Number(n);
  return v.toLocaleString("en-IN", { minimumFractionDigits: opts.decimals ?? 2, maximumFractionDigits: opts.decimals ?? 2 });
}

export function fmtNum(n, decimals = 2) {
  if (n === null || n === undefined || n === "" || isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("en-IN", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function fmtPct(n, decimals = 2) {
  if (n === null || n === undefined || n === "" || isNaN(Number(n))) return "—";
  return `${Number(n).toFixed(decimals)}%`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
  } catch (e) {
    return iso;
  }
}

export function fmtDay(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { dateStyle: "medium" });
  } catch (e) {
    return iso;
  }
}

export function stageColor(stage) {
  const m = {
    DRAFT: "bg-muted text-muted-foreground",
    KYC: "bg-info/10 text-info",
    FIELD_VERIFICATION: "bg-info/10 text-info",
    FINANCIALS: "bg-info/10 text-info",
    CMA: "bg-warning/10 text-warning",
    CRA: "bg-warning/10 text-warning",
    ASSESSMENT: "bg-warning/10 text-warning",
    SECURITY: "bg-warning/10 text-warning",
    APPROVAL: "bg-warning/10 text-warning",
    SANCTIONED: "bg-success/10 text-success",
    REJECTED: "bg-destructive/10 text-destructive",
  };
  return m[stage] || "bg-muted text-muted-foreground";
}

export function sbRatingColor(sb) {
  if (!sb) return "bg-muted text-muted-foreground border-border";
  const n = parseInt(sb.replace("SB", ""), 10);
  if (n <= 2) return "bg-success/10 text-success border-success";
  if (n <= 5) return "bg-info/10 text-info border-info";
  if (n <= 7) return "bg-warning/10 text-warning border-warning";
  return "bg-destructive/10 text-destructive border-destructive";
}

export const LOAN_TYPES = [
  { code: "CC", label: "Cash Credit (CC)" },
  { code: "TL", label: "Term Loan (TL)" },
  { code: "PERSONAL_LOAN", label: "Personal Loan" },
  { code: "HOUSING_LOAN", label: "Housing Loan" },
  { code: "MUDRA_SHISHU", label: "Mudra - Shishu (up to ₹50k)" },
  { code: "MUDRA_KISHORE", label: "Mudra - Kishore (₹50k - ₹5L)" },
  { code: "MUDRA_TARUN", label: "Mudra - Tarun (₹5L - ₹10L)" },
  { code: "SME_CC", label: "SME Cash Credit" },
  { code: "STAND_UP_INDIA", label: "Stand-Up India" },
  { code: "WC_NAYAK", label: "Working Capital (Nayak)" },
  { code: "PROJECT", label: "Project Loan" },
  { code: "CGTMSE_HYBRID", label: "CGTMSE Hybrid Model" },
];
